class CartRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: '0px 0px 100px 0px'
    });
    observer.observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    
    // Add loading state
    this.classList.add('loading');
    
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('cart-recommendations');
        if (recommendations && recommendations.innerHTML.trim().length) {
          // Clean up old mobile sheets before replacing content
          this.cleanupMobileSheets();
          
          this.innerHTML = recommendations.innerHTML;
          this.classList.remove('loading');
          this.classList.add('loaded');
          
          // Initialize Flickity galleries
          this.initializeGalleries();
        }
      })
      .catch(e => {
        console.error(e);
        this.classList.remove('loading');
      });
  }

  initializeGalleries() {
    // Initialize Flickity on all card galleries
    const galleries = this.querySelectorAll('.card-gallery');
    if (typeof Flickity !== 'undefined') {
      galleries.forEach(gallery => {
        if (!gallery.classList.contains('flickity-enabled')) {
          new Flickity(gallery, {
            cellAlign: 'center',
            contain: true,
            pageDots: true,
            prevNextButtons: true,
            wrapAround: true,
            adaptiveHeight: false,
            draggable: true
          });
        }
      });
    }
  }

  cleanupMobileSheets() {
    // Remove any orphaned mobile sheets from previous cart recommendations
    const oldSheets = document.querySelectorAll('.tcz-mobile-sheet');
    oldSheets.forEach(sheet => {
      if (sheet.parentNode === document.body && sheet.tczVariantSelector) {
        // Check if the parent element still exists in the DOM
        if (!document.contains(sheet.tczVariantSelector)) {
          document.body.removeChild(sheet);
        }
      }
    });
  }
}
customElements.define('cart-recommendations', CartRecommendations);
